import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';

import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
import SeriesType from '@/components/admin/ranking/series-type/series-type.vue'
import UploadResults from '@/components/admin/ranking/upload-results/upload-results.vue'

export default {
    name: 'RankingLayout',
    components: {
        'series-type': SeriesType,
        'upload-results': UploadResults, 
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch,
    },
    data() {
        return {
            isProcessing: false,
            errorMessage: null,
            adminOptions: ['Race Series Settings', 'Upload Race Results'],
            selectedOption: 'Race Series Settings',
            selectedSerieIndex: 0,
            selectedYearIndex: 0
        };
    },
    mounted() {
        var self = this;
        EventBus.$off('ranking-layout-set-init-serie-index');
        EventBus.$on('ranking-layout-set-init-serie-index', tabIndex => {
            self.selectedSerieIndex = tabIndex;
        });

        EventBus.$off('ranking-layout-set-init-year-index');
        EventBus.$on('ranking-layout-set-init-year-index', tabIndex => {
            self.selectedYearIndex = tabIndex;
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/ranking/ranking-layout/ranking-layout.js